import { Module } from 'vuex'
import { RootState } from '../../types'
import { SchedulingState } from './types'

const { state } = require('./state')
import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

export const scheduling: Module<SchedulingState, RootState> = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default scheduling
